import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  components: {},
  mixins: [style],
})
export default class ProductInfoButton extends Vue {
  @Prop({ default: () => {} })
    value: ItemObject;

  @Prop({ default: 1 })
    themeCode: number;

  get getButtonBg() {
    return {
      left: '#555',
      right: '#FCC600',
    };
  }

  render(h) {
    return (
      <div class="bottomBar bottom-54">
        <div class="tools-button">
          <div>
            <i class="iconfont iconhuishouye"></i>
            <p>首页</p>
          </div>
          <div>
            <i class="iconfont iconlianxidaogou"></i>
            <p>导购</p>
          </div>
          <div>
            <i class="iconfont icongouwuche2"></i>
            <p>购物车</p>
          </div>
        </div>
        <div class="buy-button">
          <div class="text-white center line-height-32" style={`background: ${this.getButtonBg.left};width: 50%;`}>
            加入购物车
          </div>
          <div class="text-black center line-height-32" style={`background: ${this.getButtonBg.right};width: 50%;`}>
            立即购买
          </div>
        </div>
      </div>
    );
  }
}
